import React, {useState, useMemo, useEffect, useCallback} from 'react';
import './Css/TotalNonPaymentHistory.css';
import CompanyInfoChip from "../Components/CompanyInfoChip";
import icon_search from "../Image/icon_search.png";
import CompanyCardListInName from "../Components/CompanyCardListInName";
import AllPaymentChip from "../Components/AllPaymentChip";
import MonthPaymentChip from "../Components/MonthPaymentChip";
// import DatePicker from "react-datepicker";
import {PaymentData, OrderedItemFieldNames, OrderedItemFieldKeys} from "../DataBind/Payment"
import {TimeData} from "../DataBind/Time"
import {toCommaedNumber} from "../DataBind/common"

// ENUM
const [VIEW_MODE_ALL, VIEW_MODE_MONTH] = ['all', 'month']
const [TIME_MODE_IN, TIME_MODE_RANGE] = ['in', 'range']
const [SORT_MODE_ALPHABET, SORT_MODE_ASC, SORT_MODE_DESC] = ['alphabet', 'asc', 'desc']

function removePrefix(text) {
    return text.replaceAll(/^㈜/g, "").replaceAll(/^\(주\)/g, "").replaceAll(/^ */g, "");
}

// 중간에 리스트 겹치는거 밖으로 뺌
function PaymentList({list, loadingState}) {

    return <>
        <div className={"Payment-paytitle-box"}>
            {/* :first* 같은 pseudo selector? 를 쓰는편이 클래스네임 분리보다 더 보기좋을지도 */}
            <div className={'pay-1'}>업체명</div>
            <div className={'pay'}>년월</div>
            {OrderedItemFieldNames.map(name => <div key={name} className={'pay'}>{name}</div>)}
            <div className={'pay'}>총 미납액</div>
        </div>
        {loadingState ? (
            <div className="sidebar-loader"></div> // 로딩 스피너 출력
        ) : (
            list?.map(payment => <CompanyCardListInName key={payment.id} data={payment}/>))
        }
        <div className={"Payment-under-box"}>
            <div className={'show-pay1'}>
                <div className={'show-pay1-text1'}>
                    {OrderedItemFieldKeys.flatMap((key, index) => [
                        <a key={key + ".a"}>{OrderedItemFieldNames[index]}</a>,
                        <b key={key + ".b"}> : {toCommaedNumber(list?.reduce((base, val) => base + val[key], 0) ?? 0)} 원</b>
                    ])}
                </div>
            </div>
            <div className={'show-pay2-1'}>
                합계 : {toCommaedNumber(list?.reduce((base, val) => base + val.total, 0) ?? 0)}원
            </div>
        </div>
    </>
}

// 단일 선택 칩
function SelectionChip({list, value, onValueChange}) {
    return list.map(item =>
        <button
            key={item.value}
            className={`TotalNonPaymentHistory-btn ${value === item.value ? 'selected' : ''}`}
            onClick={() => onValueChange(item.value)}
        >
            {item.text}
        </button>
    )
}

// 시간 선택기
function TimeSelector({
                          minMaxDate,
                          availableYears,
                          selectedIn,
                          onChangeSelectedIn,
                          timeMode,
                          onChangeTimeMode,
                          selectedRange,
                          onChangeSelectedRange
                      }) {
    return (
        <div className={'select-month-box'}>
            <label className="TotalNonPaymentHistoryCheckBox">
                <input
                    type="checkbox"
                    checked={timeMode == TIME_MODE_IN}
                    onChange={() => onChangeTimeMode(TIME_MODE_IN)}
                />
                <div className="TotalNonPaymentHistoryCheckmark"></div>
            </label>

            <select
                id="dropdown-year"
                className="TotalNonPaymentHistory-dropdown dropdown-year"
                value={selectedIn.year}
                onChange={({target}) => onChangeSelectedIn({...selectedIn, year: target.value})}
                disabled={timeMode != TIME_MODE_IN} // 오른쪽 체크박스가 체크되면 비활성화
                // select:disabled 로 선택해서 스타일링 해주세요
            >
                <option value="" disabled>년</option>
                {availableYears?.map(year =>
                    <option key={year} value={year}>{year}</option>
                )}
                <option value={'all'}>전부</option>
            </select>
            <select
                // 나중에 month 로 다시 작명해주세요
                id="dropdown-day"
                className="TotalNonPaymentHistory-dropdown dropdown-day"
                value={selectedIn.month}
                onChange={({target}) => onChangeSelectedIn({...selectedIn, month: target.value})}
                disabled={timeMode != TIME_MODE_IN} // 오른쪽 체크박스가 체크되면 비활성화
            >
                <option value="" disabled>월</option>
                {new Array(12).fill(null).map((_, index) => <option key={index} value={index + 1}>{index + 1}</option>)}
                <option value={'all'}>전부</option>
            </select>

            <label className="TotalNonPaymentHistoryCheckBox">
                <input
                    type="checkbox"
                    checked={timeMode == TIME_MODE_RANGE}
                    onChange={() => onChangeTimeMode(TIME_MODE_RANGE)}
                />
                <div className="TotalNonPaymentHistoryCheckmark"></div>
            </label>

            <div className="date-range-picker">
                <div className="date-input">
                    <label className="date-label">Start month</label>
                    <input
                        // input[type="months"]
                        // spec check: 사파리랑 파이어폭스 미지원입니다 (no major support)
                        type="date" // safari 14.1, firefox 12 오래전부터 지원
                        min={minMaxDate?.[0]?.toText()}
                        max={minMaxDate?.[1]?.toText()}
                        value={selectedRange.start?.toText()}
                        onChange={({target}) => {
                            const value = TimeData.fromText(target.value)
                            if (selectedRange.end.toNumber() < value.toNumber()) {
                                selectedRange.end = value
                            }
                            onChangeSelectedRange({...selectedRange, start: value})
                        }}
                        className="date-input-field"
                        disabled={timeMode != TIME_MODE_RANGE} // 왼쪽 체크박스가 체크되면 비활성화
                    />
                </div>

                <span className="date-divider">~</span>

                <div className="date-input">
                    <label className="date-label">End month</label>
                    <input
                        type="date"
                        min={minMaxDate?.[0]?.toText()}
                        max={minMaxDate?.[1]?.toText()}
                        value={selectedRange.end?.toText()}
                        onChange={({target}) => {
                            const value = TimeData.fromText(target.value)
                            if (selectedRange.start.toNumber() > value.toNumber()) {
                                selectedRange.start = value
                            }
                            onChangeSelectedRange({...selectedRange, end: value})
                        }}
                        className="date-input-field"
                        disabled={timeMode != TIME_MODE_RANGE} // 왼쪽 체크박스가 체크되면 비활성화
                    />
                </div>
            </div>
        </div>
    )
}

// 아마 처음 render 할 때 스켈레톤프레임 하나 넣어주셔야 할듯 해요
// (로드중에 비어있는게 허전함)
const TotalNonPaymentHistory = () => {
    const [selectedSort, setSelectedSort] = useState("alphabet"); // 전체 뷰에서 선택된 소팅법
    const [displayMode, setDisplayMode] = useState(VIEW_MODE_ALL); // 선택된 뷰
    const [timeMode, setTimeMode] = useState(TIME_MODE_IN); // 시간 선택 방식 (A~B 기간 또는 년월)
    const [selectedRange, setSelectedRange] = useState({start: null, end: null});
    const [selectedIn, setSelectedIn] = useState({year: null, month: null}) // 선택된 년월 << 묶을만한 state 는 좀 묶어주세요...
    const [loading, setLoading] = useState(true); // 로딩 상태

    const list = PaymentData.use() // 백엔드에서 목록 가져오기
    // 대안 모의 데이터
    // const list = useCallback([
    //     new PaymentData({company: "가", createTime:TimeData.fromText("2025-12-1"), electric: 100, gas: 111, rent: 123, room: 1, surtax: 123123, total: 1233, id: 12312}),
    //     new PaymentData({company: "나", createTime:TimeData.fromText("2024-11-2"), electric: 100, gas: 111, rent: 123, room: 1, surtax: 123123, total: 1233, id: 121312}),
    //     new PaymentData({company: "다", createTime:TimeData.fromText("2024-10-3"), electric: 100, gas: 111, rent: 123, room: 1, surtax: 123123, total: 1233, id: 1211312}),
    // ],[])

    // 목록에 있는 년도들 (소팅된 array)
    const availableYears = useMemo(
        () => list ? [...list.reduce((set, val) => set.add(+val.createTime.year), new Set())].sort((a, b) => b - a) : null,
        [list]
    )

    // selectedIn 초기값 설정
    useEffect(() => {
        setSelectedIn({
            year: availableYears?.[0],
            month: list?.reduce((base, val) => Math.max(base, val.createTime.month), 0),
        })
    }, [availableYears])

    // 최소일 최대일
    const minMaxDate = useMemo(
        () => list?.reduce((result, val) => {
            let num = val.createTime.toNumber()
            if (num < result[0]) result[0] = num
            if (num > result[1]) result[1] = num
            return result
        }, [99999999, 0])?.map(num => TimeData.fromNumber(num)),
        [list]
    )

    // selectedRange 초기값 설정
    useEffect(() => {
        if (!minMaxDate) return
        selectedRange.start ??= minMaxDate[0]
        selectedRange.end ??= minMaxDate[1]
        setSelectedRange({...selectedRange})
    }, [minMaxDate])

    // sort 와 filter 완료된 list
    const filteredAndSorted = useMemo(
        () => list?.filter(item => item.total !== 0)?.filter(item => {
            if (displayMode == VIEW_MODE_ALL) {
                // 전체보기 상태에선 필터할것 없음
                return true
            } else if (displayMode == VIEW_MODE_MONTH) {
                // 월별보기 상태에서
                if (timeMode == TIME_MODE_IN) {
                    // 선택된 월
                    if (selectedIn.year != null && selectedIn.year != 'all' && (item.createTime.year + "") != selectedIn.year)
                        return false
                    if (selectedIn.month != null && selectedIn.month != 'all' && (item.createTime.month + "") != selectedIn.month)
                        return false
                    return true
                } else if (timeMode == TIME_MODE_RANGE) {
                    // 선택된 기간
                    if ((selectedRange?.start?.compare(item.createTime) ?? 0) > 0)
                        return false
                    if ((selectedRange?.end?.compare(item.createTime) ?? 0) < 0)
                        return false
                    return true
                }
            }
        })?.sort((a, b) => {
            if (displayMode == VIEW_MODE_ALL) {
                switch (selectedSort) {
                    case SORT_MODE_ALPHABET:
                        setLoading(false)
                        return removePrefix(a.company) < removePrefix(b.company) ? -1 : 1
                    case SORT_MODE_ASC:
                        setLoading(false)

                        return -a.createTime.compare(b.createTime)
                    case SORT_MODE_DESC:
                        setLoading(false)

                        return a.createTime.compare(b.createTime)
                }
            } else if (displayMode == VIEW_MODE_MONTH) {
                setLoading(false)

                return -a.createTime.compare(b.createTime)
            }
        }
        ),
        [list, selectedIn, selectedSort, displayMode, timeMode, selectedRange]
    )

    return (
        <div className="registration-container">

            <div className="registration-middle-container">
                <div className="registration-sidebar">
                    <div className="search">
                        <img className="icon_search" src={icon_search} alt="See more"/>
                        <input
                            className="search-bar"
                            placeholder="업체명을 입력하세요"
                        />
                    </div>
                    <AllPaymentChip onClick={() => setDisplayMode(VIEW_MODE_ALL)} listCount={list === null ? 0 : list.length} />
                    <MonthPaymentChip onClick={() => setDisplayMode(VIEW_MODE_MONTH)} />
                    {/* {list?.map(item => (
                        <CompanyInfoChip key={item.company} name={item.company}/>
                    ))} */}
                </div>

                <div className={'TotalNonPaymentHistory-mainbox'}>
                    {/* 가변 타이틀 */}
                    <div className={'TotalNonPaymentHistory-title'}>{{
                        [VIEW_MODE_ALL]: "전체 미납내역",
                        [VIEW_MODE_MONTH]: "월별 내역 모아보기"
                    }[displayMode]}</div>
                    {/* 가변 서브타이틀 */}
                    <div className={'TotalNonPaymentHistory-sub-title'}>{{
                        [VIEW_MODE_ALL]: "현재까지 미납된 업체 및 금액을 모두 확인하세요.",
                        [VIEW_MODE_MONTH]: "원하는 기간대의 납부내역을 확인해보세요."
                    }[displayMode]}</div>
                    {/* 내용 박스 */}
                    <div className={'showFullDetails'}>
                        {
                            displayMode == VIEW_MODE_ALL
                                // 전체 보기 상태에서 띄울 칩
                                ? <div className={'TotalNonPaymentHistory-btn-box'}>
                                    <SelectionChip
                                        list={[
                                            {text: "업체명 가나다순", value: SORT_MODE_ALPHABET},
                                            {text: "년/월 오름차순", value: SORT_MODE_ASC},
                                            {text: "년/월 내림차순", value: SORT_MODE_DESC}
                                        ]}
                                        onValueChange={setSelectedSort}
                                        value={selectedSort}
                                    />
                                </div>
                                // 월별보기 상태에서 띄울 선택기
                                : <TimeSelector
                                    minMaxDate={minMaxDate}
                                    availableYears={availableYears}
                                    selectedIn={selectedIn}
                                    onChangeSelectedIn={setSelectedIn}
                                    timeMode={timeMode}
                                    onChangeTimeMode={setTimeMode}
                                    selectedRange={selectedRange}
                                    onChangeSelectedRange={setSelectedRange}
                                />
                        }
                        {/* 표시할 리스트 */}
                        <PaymentList list={filteredAndSorted} loadingState={loading}/>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TotalNonPaymentHistory;
